// extracted by mini-css-extract-plugin
export default {"manager":"NotificationsManager__manager--z_PRL"};